export const Question = ({ className }: { className?: string }) => (
  <div
    style={{ padding: "10px" }}
    className={`rounded-circle bg-primary text-white position-relative ${
      className ?? ""
    }`}
  >
    <strong
      style={{
        top: "-5%",
        left: "31%",
      }}
      className={"position-absolute"}
    >
      ?
    </strong>
  </div>
);
